// Custom Components
import Button from '../components/base/Button'
import styles from './GetStarted.module.css'

const RequestConsultation = () => {
    return (
        <>
            <div className={styles.getStarted}>
                <h2 className="font-semibold text-primary-900">
                    Book a Free Technical Consultation
                </h2>
                <p className={styles.description}>
                    Tell us a little bit about your business, and we’ll tell you
                    how our Data Scientists team can help with a free
                    consultation & proposal.
                </p>
                <div className="flex items-center justify-center">
                    <Button
                        text="Request a consulation"
                        type="button"
                        variant="primary"
                        size="lg"
                        link="/contact"
                    />
                </div>
            </div>
        </>
    )
}
export default RequestConsultation
